import $ from 'jquery';

import renderProductSecurityRegulations from './templates/product-security-regulation.tpl.html';

// JIT = Load when TabItem is clicked
// Other = Load when TabContainer get scrolled into view.
const mode = 'JIT';

class ProductSecurityRegulationTab  {

	#TABID = 'productsecurityregulation';

	constructor( tabContainerEl ) {
		this.tabContainerEl = tabContainerEl;

		// Get Content containing element.
		this.tabContentEl = tabContainerEl.querySelector( `.en_tab__item[data-tab-id="${this.#TABID}"]` );

		// Get NavItems.
		const allNavItemEls = Array.from( tabContainerEl.querySelectorAll( '.en_tab__nav_item,.en_tab__trigger_item' ) );
		this.tabNavItemEls = allNavItemEls.filter( navItemEl => navItemEl.matches( `[data-tab-id="${this.#TABID}"]` ) );
	}

	isLoading = false;
	setLoading( isLoading ) {
		this.isLoading = isLoading;
	}

	setupLazyload() {
		const EN_KO = window.EN_KO;
		EN_KO.functions.initSimpleLazyLoadOnScroll( this.tabContentEl, 'en_tab__item--loaded', () => this.onActivate() );
		this.tabNavItemEls.forEach( tabNavItemEl => tabNavItemEl.classList.remove( 'en_hidden' ) );
	}

	onActivate() {
		this.setLoading( true );
		return this.fetchData().then( async( regulations ) => {
			const EN = window.EN;
			return EN.Render.render( 'product-security-regulation', { regulations } ).then( renderedHTML => {
				this.tabContentEl.firstElementChild.innerHTML = renderedHTML;

				// Show Tab, when loaded.
				this.tabNavItemEls.forEach( tabNavItemEl => tabNavItemEl.classList.remove( 'en_hidden' ) );
				return regulations;
			} );
		} ).catch( err => {
			console.error( err ); // eslint-disable-line no-console
			const messageEl = this.tabContentEl.querySelector( 'noscript' );
			if ( messageEl ) {
				const replaceEl = document.createElement( 'div' );
				replaceEl.innerHTML = messageEl.innerHTML;
				this.tabContentEl.firstElementChild.replaceChildren( replaceEl );
			}

			if ( 'JIT' !== mode ) {
				// Hide TabNavItem Elements.
				this.tabNavItemEls.forEach( tabNavItemEl => tabNavItemEl.classList.add( 'en_hidden' ) );
			}
		} ).finally( () => {
			this.setLoading( false );
		} )
	}

	static cache = {};

	fetchData() {
		const brand = this.tabContentEl.dataset.brandId;
		const article = this.tabContentEl.dataset.article;

		if ( this.constructor.cache[ article ] ?? false ) {
			return Promise.resolve( this.constructor.cache[ article ] );
		}

		// No need to call the same brand twice.
		if ( this.promise ) {
			return this.promise;
		}

		const params = new URLSearchParams( {
			'cl': 'external_frontend-data',
			'fnc': 'getLieferantenadresse',
			'brand': brand,
			'article': article,
		} );

		this.promise = fetch( `/index.php?${params.toString()}` )
			.then( async( res ) => {
				if ( res.ok ) {
					return await res.json();
				}
				return await Promise.reject( await res.json() );
			} ).then( res => {
				if ( res && res.length > 0 ) {
					this.constructor.cache[ article ] = res;
					return res;
				}
				return Promise.reject( res );
			} );

		return this.promise;
	}

	static getInstance( tabContainerEl ) {
		tabContainerEl.KOE_PRODUCT_SECURITY_REGULATION_TAB ??= new ProductSecurityRegulationTab( tabContainerEl );
		return tabContainerEl.KOE_PRODUCT_SECURITY_REGULATION_TAB;
	}
}

const initProductSecurityRegulation = ( scopeEl = document ) => {

	// Get Container Els.
	const tabContainerEls = scopeEl.querySelectorAll( '.en_tab__container' );

	// Activate on scrollIntoView.
	const EN_KO = window.EN_KO;
	EN_KO.functions.initSimpleLazyLoadOnScroll( tabContainerEls, 'en_tab__container--psr-loaded', ( tabContainerEl ) => {
		const tabContentEl = tabContainerEl.querySelector( '.en_tab__item[data-tab-id="productsecurityregulation"]' )
		if ( tabContentEl ) {
			const instance = ProductSecurityRegulationTab.getInstance( tabContainerEl );
			if ( 'JIT' === mode ) {
				instance.setupLazyload();
			} else {
				instance.onActivate();
			}
		}
	} );
}

// Load Regulation on Variant change.
document.addEventListener( 'finished_change_variant', ( ev ) => initProductSecurityRegulation( ev.target ) );

$( document ).ready( function() {
	const EN = window.EN;
	EN.Render.addTemplate( 'product-security-regulation', renderProductSecurityRegulations );
} );
